import { resetAllStores } from '../store/resetStores';

// 두 가지 일자 중 나중 일자
export function getBiggerDate( date1:any, date2:any ){
  const DATE1:any = new Date( date1 );
  const DATE2:any = new Date( date2 );
  const bigger = Math.max(  Math.floor( DATE1 / 1000) , Math.floor( DATE2 / 1000) );
  
  return new Date( bigger * 1000 );
}

// 두 가지 일자 중 이전 일자
export function getSmallerDate( date1:any, date2:any ){
  const DATE1:any = new Date( date1 );
  const DATE2:any = new Date( date2 );
  const bigger = Math.min(  Math.floor( DATE1 / 1000) , Math.floor( DATE2 / 1000) );
  
  return new Date( bigger * 1000 );
}

// 이메일 체크 정규식
export function isEmail(asValue:any) {
	const regExpOneDot = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]+$/i;
	const regExpTowDot = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]+\.[a-zA-Z]+$/i;
  
	return ( regExpOneDot.test(asValue) || regExpTowDot.test(asValue) ); // 형식에 맞는 경우 true 리턴
}

// 일자로 요일 검색 후 요일 텍스트 리턴 (param format: yyyy-MM-dd)
export function getDayOfWeek(yyyyMMdd:any){
  const dayOfWeek = new Date(yyyyMMdd).getDay();
  switch ( dayOfWeek ) {
    case 0 : return '일';
    case 1 : return '월';
    case 2 : return '화';
    case 3 : return '수';
    case 4 : return '목';
    case 5 : return '금';
    case 6 : return '토';
    default: return '일';
  }
}

// date to string 원하는 포맷 및 일자(오늘 기준 0, 이전 마이너스, 이후 플러스 값)
export function getDateByCustom(format :any, dayValue :any) {
  let returnStr = '';
  const today = new Date();
  const targetDay = new Date(today.setDate(today.getDate() + (dayValue)));
  const year = targetDay.getFullYear();
  const month = (targetDay.getMonth() + 1) >= 10 ? (targetDay.getMonth() + 1) : '0' + (targetDay.getMonth() + 1);
  const date = targetDay.getDate() >= 10 ? targetDay.getDate() : '0' + targetDay.getDate();
  
  if(format === 'yyyyMMdd'){
    returnStr = year + '' + month + '' + date;
  }else if (format === 'yyyy-MM-dd'){
    returnStr = year + '-' + month + '-' + date;
  }
  
	return returnStr;
}

/**
 * localStorage 에 넣어둔 JSON 을 안전하게 읽는다. 없거나 깨졌으면 null.
 *
 * 이 프로젝트 곳곳에 `JSON.parse(localStorage.getItem(k) || '')` 가 있는데,
 * 키가 없으면 `JSON.parse('')` 가 SyntaxError 를 던진다. 그 예외가 예약 취소처럼
 * 중요한 흐름 한가운데서 나면 뒤따르는 화면 갱신이 통째로 실행되지 않는다
 * (서버에서는 처리됐는데 화면은 그대로라 사용자가 같은 동작을 반복하게 된다).
 * 값은 예약 화면을 거쳐야 저장되므로, 로그인 직후처럼 없는 상태가 정상이다.
 */
export function readStoredJson(key: string): any {
  const raw = window.localStorage.getItem(key);
  if (raw === null || raw === '') return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

// null check
export function strNull(val :any){
  if (new String(val).valueOf() == 'undefined')
    return '';
  if (val == null)
    return '';
  if (('x' + val == 'xNaN') && (new String(val.length).valueOf() == 'undefined'))
    return '';
  if (val.toString().length == 0)
    return '';
  
  return val.toString();
}

// 로그아웃 후에도 유지할 항목 (zustand persist 스토어명 : 유지 대상 state 키)
//
// 기기 선택은 같은 계정으로 다시 로그인했을 때 다시 고르게 하지 않으려고 남긴다.
// 다만 AP_009_003 은 이 목록을 **계정별로** 저장하므로, 소유자(selectedDeviceOwner)를
// 반드시 함께 남겨야 한다. 목록만 남기면 다른 계정으로 로그인했을 때 이전 계정의
// 선택이 그대로 보이고, 그 상태로 저장하면 새 계정의 서버 등록을 덮어쓴다.
// 읽는 쪽은 historyStore 의 selectedDevicesOf 로 소유자를 확인한다.
const KEEP_STORE_KEYS_ON_LOGOUT: { [storeName: string]: string[] } = {
  historyStore: ['selectedDeviceList', 'selectedDeviceOwner'],
};

// 로그아웃 처리 - 유지 대상을 제외하고 localStorage 초기화 (회원 탈퇴는 전체 초기화)
export function clearLoginStorage() {
  const keepItems: { [key: string]: string } = {};

  Object.keys(KEEP_STORE_KEYS_ON_LOGOUT).forEach((storeName) => {
    const saved = window.localStorage.getItem(storeName);
    if (saved === null) {
      return;
    }
    try {
      const parsed = JSON.parse(saved);
      const keepState: any = {};
      KEEP_STORE_KEYS_ON_LOGOUT[storeName].forEach((stateKey) => {
        if (parsed.state !== undefined && parsed.state !== null && parsed.state[stateKey] !== undefined) {
          keepState[stateKey] = parsed.state[stateKey];
        }
      });
      if (Object.keys(keepState).length > 0) {
        keepItems[storeName] = JSON.stringify({ ...parsed, state: keepState });
      }
    } catch (e) {
      // 저장 형식이 맞지 않으면 유지하지 않고 함께 초기화
    }
  });

  window.localStorage.clear();

  Object.keys(keepItems).forEach((key) => {
    window.localStorage.setItem(key, keepItems[key]);
  });

  // 저장소만 비우면 절반만 지운 것이다.
  // zustand persist 는 앱 로드 시 localStorage 를 한 번 읽어 메모리를 채우고 그 뒤로는
  // 메모리가 원본이다. 이 앱은 로그아웃·로그인이 전부 soft navigation 이라 페이지가
  // 다시 로드되지 않으므로, 여기서 메모리까지 비우지 않으면 직전 계정의 예약 정보·
  // 건강 정보가 다음 계정 화면에 그대로 남고, 새 계정에서 값이 한 번 바뀌는 순간
  // persist 가 그 데이터를 localStorage 에 다시 써넣는다.
  resetAllStores();
}

// time(단위 시간), mets 값, 몸무게를 통해 소비칼로리 계산 // return 소수점 5자리 반올림 후 number로 0 제거
export function getCaloryByMets(time :any, mets :any, weight :any){
  return Number((time*mets*weight*1.05).toFixed(5));
}

// time(단위 시간), 소비칼로리, 몸무게를 통해 mets 값 계산
export function getMetsByCalory(time :any, calory :any, weight :any){
  return calory/(time*weight*1.05);
}

// 숫자 3자리마다 콤마 찍기!
export function formatComma(num :any){
  return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// 핸드폰번호 010-0000-0000 포맷 실시간 하이픈(-) 추가
export function formatPhoneNumber(value: any) {
  if (!value) {
    return "";
  }

  value = value.replace(/[^0-9]/g, "");

  let result = [];
  let restNumber = "";

  // 지역번호와 나머지 번호로 나누기
  if (value.startsWith("02")) {
    // 서울 02 지역번호
    result.push(value.substr(0, 2));
    restNumber = value.substring(2);
  } else if (value.startsWith("1")) {
    // 지역 번호가 없는 경우
    // 1xxx-yyyy
    restNumber = value;
  } else {
    // 나머지 3자리 지역번호
    // 0xx-yyyy-zzzz
    result.push(value.substr(0, 3));
    restNumber = value.substring(3);
  }

  if (restNumber.length === 7) {
    // 7자리만 남았을 때는 xxx-yyyy
    result.push(restNumber.substring(0, 3));
    result.push(restNumber.substring(3));
  } else {
    result.push(restNumber.substring(0, 4));
    result.push(restNumber.substring(4));
  }

  return result.filter((val) => val).join("-");
}

/**
 * gauge chart 혈압 값에 따른 percent (낮음 15 / 정상 50 / 높음 85).
 *
 * 측정값이 없으면 null 을 돌려준다 — GaugeChart 가 이때 '미측정'으로 표시한다.
 * 예전에는 (0, 0) 도 50 을 돌려줘서, 혈압을 한 번도 재지 않은 사용자에게
 * 바늘이 정상 구간 한가운데를 가리켰다.
 */
export function getPercentValueForGauge(targetPressure: any): number | null {
  const low = Number(targetPressure?.bloodPressureLow);
  const high = Number(targetPressure?.bloodPressureHigh);
  // 미측정: 값이 없거나 숫자가 아니거나 둘 다 0
  if (!Number.isFinite(low) || !Number.isFinite(high)) return null;
  if (low === 0 && high === 0) return null;

  if ((low >= 61 && low <= 80) && (high >= 101 && high <= 120)) {
    return 50;
  } else if (low > 80 || high > 120) {
    return 85;
  } else if (low < 61 || high < 101) {
    return 15;
  }
  return null;
}

//2026-08-11 수정
// 최근에 측정한 혈당
export function getLatestValue(targetBlood: any) {
  // 원하는 순서대로 키와 추가 속성을 배열에 정의
  // const keyOrder = [
  //   { key: "bloodSugarMorning", type: "before" },
  //   { key: "bloodSugarMorningAfter", type: "after" },
  //   { key: "bloodSugarLunch", type: "before" },
  //   { key: "bloodSugarLunchAfter", type: "after" },
  //   { key: "bloodSugarDinner", type: "before" },
  //   { key: "bloodSugarDinnerAfter", type: "after" },
  //   { key: "bloodSugarSleep", type: "sleep" }
  // ];
  const keyOrder = [
    { key: "breakfast_pre", type: "before" },
    { key: "breakfast_post", type: "after" },
    { key: "lunch_pre", type: "before" },
    { key: "lunch_post", type: "after" },
    { key: "dinner_pre", type: "before" },
    { key: "dinner_post", type: "after" },
    { key: "sleep", type: "sleep" }
  ];

  // 데이터 자체가 없는 경우
  if (!targetBlood) {
    return {
      type: 0,
      bloodValue: 0
    };
  }

  const lastValue = keyOrder
      .map(item => ({
        value: targetBlood[item.key],
        type: item.type
      }))
      .reverse()
      .find(item =>
          item.value !== undefined &&
          item.value !== null &&
          item.value !== 0
      );

  return {
    type: lastValue ? lastValue.type : 0,
    bloodValue: lastValue ? lastValue.value : 0
  };
}
  
// type과 bloodValue에 따른 status, color, gaugeValue 값 리턴
export function getPressureStatusAndColor(type: any, bloodValue: any) {
  let status = '없음';
  let color = '#333'; // 기본 색상 설정
  let gaugeValue: number | null = 50;

  switch (type) {
    case 'before':
      if (bloodValue < 70) {
        status = '낮음';
        color = '#fba400';
        gaugeValue = 15;
      } else if (bloodValue >= 70 && bloodValue <= 100) {
        status = '정상';
        color = '#279700';
        gaugeValue = 50;
      } else {
        status = '높음';
        color = '#df0000';
        gaugeValue = 85;
      }
      break;

    case 'after':
      if (bloodValue < 90) {
        status = '낮음';
        color = '#fba400';
        gaugeValue = 15;
      } else if (bloodValue >= 90 && bloodValue <= 140) {
        status = '정상';
        color = '#279700';
        gaugeValue = 50;
      } else {
        status = '높음';
        color = '#df0000';
        gaugeValue = 85;
      }
      break;

    case 'sleep':
      if (bloodValue < 100) {
        status = '낮음';
        color = '#fba400';
        gaugeValue = 15;
      } else if (bloodValue >= 100 && bloodValue <= 150) {
        status = '정상';
        color = '#279700';
        gaugeValue = 50;
      } else {
        status = '높음';
        color = '#df0000';
        gaugeValue = 85;
      }
      break;

    default:
      // 측정값 없음 — 게이지를 그리지 않는다 (GaugeChart 가 '미측정'으로 표시).
      // 예전에는 50 을 줘서 바늘이 정상 구간 한가운데를 가리켰다.
      status = '없음';
      color = '#777';
      gaugeValue = null;
      break;
  }

  return {
    status, color, gaugeValue
  };
}